/**
 * Chrome for the phone scroll affordance shared by every horizontally
 * scrolling strip (status pills, report tabs, insight tabs).
 *
 * One block so the three rails cannot drift apart. Colours are literal here
 * rather than from `theme.palette` because the affordance is a surface
 * treatment, not a semantic one — the fade has to match whatever the strip is
 * drawn on, which the caller passes in as `surface`.
 */
import { formField, signer, white } from "theme/colors";

export const scrollHintTokens = {
  /** Trailing space reserved in the scroller so the last item clears the button. */
  width: 44,
  buttonSize: 28,
  iconSize: 15,
  radius: "999px",
  border: formField.borderWarm,
  color: signer.ink,
  shadow: "0 1px 4px rgba(33,21,71,.10)",
  /** Fade runs from this to the surface colour. */
  transparent: "rgba(255,255,255,0)",
  fadeWidth: "56px",
  /** Default surface the strips sit on. */
  surface: white,
} as const;

export default scrollHintTokens;
